import { useEffect } from 'react';
import { pendoInitializeFromLocalStorage, pendoPageLoad } from 'utils/pendo';
import type { useSessionVerification } from 'hooks/useSessionVerification';

type SessionMember = ReturnType<typeof useSessionVerification>['member'];

/**
 * Initializes Pendo for the signed-in user, retrying until the agent script
 * has loaded, then reports a page load on every route change.
 */
export const usePendoLifecycle = (
  isAuthenticated: boolean,
  member: SessionMember,
  pathname: string,
  search: string
): void => {
  useEffect(() => {
    if (!isAuthenticated) return;
    let cancelled = false;
    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    const tryInit = () => {
      if (cancelled) return;
      const ok = pendoInitializeFromLocalStorage();
      if (!ok) {
        timeoutId = setTimeout(tryInit, 300);
      }
    };

    tryInit();

    return () => {
      cancelled = true;
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [isAuthenticated, member]);

  useEffect(() => {
    if (!isAuthenticated) return;
    pendoPageLoad();
  }, [isAuthenticated, pathname, search]);
};
